<template>
  <a-modal v-model="modal" title="刷新包装版本号" width="500px" :maskClosable="false" :closable="false">
    <a-form-model :model="formData" ref="form" v-if="modal">
      <a-form-model-item
        label="工单当前包装版本号为"
        :labelCol="{ style: 'width: 150px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 150px ) !important;float:left'}"
        prop="currentPackageVersion">
        <div v-if="data.currentPackageVersion.packageMaterialBomVersion">
          {{ `${data.currentPackageVersion.packageMaterialBomVersion} （${data.currentPackageVersion.packageTotalPackage}包）` }}
        </div>
        <div v-else>无</div>
      </a-form-model-item>
      <a-form-model-item
        label="工单最新包装版本号为"
        :labelCol="{ style: 'width: 150px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 150px ) !important;float:left'}"
        prop="latestPackageVersion">
        <div v-if="data.latestPackageVersion.packageMaterialBomVersion">
          {{ `${data.latestPackageVersion.packageMaterialBomVersion} （${data.latestPackageVersion.packageTotalPackage}包）` }}
        </div>
        <div v-else>无</div>
      </a-form-model-item>
      <a-form-model-item
        label="刷新包装版本号为"
        :labelCol="{ style: 'width: 150px;float:left' }"
        :wrapperCol="{ style:'width:calc(95% - 150px ) !important;float:left'}"
        :rules="rules.packageVersion"
        prop="packageVersion">
        <a-select show-search v-model="formData.packageVersion">
          <a-select-option v-for="(item) in data.packageVersionList" :key="item.packageMaterialBomVersion">
            {{ `${item.packageMaterialBomVersion} （${item.packageTotalPackage}包）` }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button @click="modal=false;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { apiMesGetItemPackageVersion, apiWorkOrderDeskRefreshVersion, apiWorkOrderSentRefreshVersion } from '@/api/mes/workOrderManage/workOrderDesk'
export default {
  name: 'RefreshVersionModal',
  data () {
    return {
      type: 'workOrderDesk',
      modal: false,
      formData: {},
      data: { currentPackageVersion: {}, latestPackageVersion: {}, packageVersionList: [] },
      loading: false,
      rowData: {},
      rules: {
        packageVersion: [{ required: true, message: ' ', trigger: 'change' }]
      }
    }
  },
  methods: {
    show (row, type) {
      this.rowData = row
      this.type = type
      this.initSearch()
      this.modal = true
    },
    // 初始化查询
    initSearch() {
      this.data = { currentPackageVersion: {}, latestPackageVersion: {}, packageVersionList: [] }
      this.$set(this.formData, 'packageVersion', '')
      this.loading = true
      apiMesGetItemPackageVersion({ id: this.rowData.id }).then(res => {
        if (res?.code === 200) {
          const { currentPackageVersion, latestPackageVersion, packageVersionList } = res.data;
          this.$set(this.data, 'currentPackageVersion', currentPackageVersion || {})
          this.$set(this.data, 'latestPackageVersion', latestPackageVersion || {})
          this.$set(this.data, 'packageVersionList', packageVersionList || [])
          if (res?.data?.packageVersionList?.length > 0) {
            this.$set(this.formData, 'packageVersion', res.data.packageVersionList[0]?.packageMaterialBomVersion)
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 确认
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const apiRequest = this.type === 'workOrderDesk' ? apiWorkOrderDeskRefreshVersion : apiWorkOrderSentRefreshVersion
          apiRequest({ id: this.rowData.id, packageVersion: this.formData.packageVersion }).then(res => {
            if (res.code === 200) {
              // this.$message.success(res?.data || '操作成功!')
              this.$success({
                title: '提示',
                content: (res?.data || '操作成功!'),
                okText: '确定'
              });
              this.$emit("reSearch")
              this.modal = false
            } else {
              this.$message.error(res?.msg)
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
